import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/** Order details of the cart step as chips: buyer email, selected date and time. */
@Component({
  selector: 'app-order-recap',
  templateUrl: './order-recap.component.html',
  styleUrls: ['./order-recap.component.scss'],
  standalone: true,
  imports: [DatePipe, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderRecapComponent {
  @Input() email: string | null = null;
  @Input() date: Date | null = null;
  @Input() time: string | null = null;
}
